import { merge, keyBy, cloneDeep } from 'lodash';
import { rearrangeArrayValue } from '@nile/components';

const boardReducer = (state, action) => {
  switch (action.type) {
    case 'moveCard':
      const newState = cloneDeep(state);
      const sourceList = newState.findIndex(
        (el) => el.id === action.sourceListId
      );
      const targetList = newState.findIndex(
        (el) => el.id === action.targetListId
      );
      if (action.sourceListId === action.targetListId) {
        newState[targetList].items.splice(action.removedIndex, 1);
        newState[targetList].items.splice(action.addedIndex, 0, action.item);
      } else {
        newState[targetList].items.splice(action.addedIndex, 0, action.item);
        newState[sourceList] = {
          ...newState[sourceList],
          items: newState[sourceList].items.filter((el) => {
            return el.id !== action.item.id;
          })
        };
      }

      return newState;
    case 'pinColumn':
      let clonedState = cloneDeep(state);
      const { data, pinnedIndex, boardIndex } = action.meta;
      if (pinnedIndex !== boardIndex) {
        rearrangeArrayValue(clonedState, boardIndex, pinnedIndex);
        // clonedState.splice(boardIndex, 1);
        // clonedState.splice(pinnedIndex, 0, data);
      }
      return clonedState;
    case 'unpinColumn':
      // On unpin move the unpinned column to the last position
      // const cloneState = cloneDeep(state);
      // const { data: columnData, boardIndex: currIndex } = action.meta;
      // if (currIndex) {
      //   cloneState.splice(currIndex, 1);
      //   cloneState.push(columnData);
      // }
      return state;
    case 'moveList':
      const boardState = cloneDeep(state);
      const { payload, addedIndex, removedIndex } = action.meta;
      if (addedIndex !== removedIndex) {
        boardState.splice(removedIndex, 1);
        boardState.splice(addedIndex, 0, payload.item);
      }
      return boardState;
    case 'updateList':
      const updatedState = cloneDeep(state);
      const listToUpdate = state.findIndex((el) => el.id === action.list.id);
      const newParams = action.params || {};
      updatedState[listToUpdate] = {
        ...updatedState[listToUpdate],
        ...newParams,
        items: action.items
      };
      return updatedState;
    case 'addList':
      const newListAddedState = cloneDeep(state);
      newListAddedState.push(action.list);
      return newListAddedState;
    case 'addLists':
      const newListsAddedState = cloneDeep(state);
      return [...newListsAddedState, ...action.lists];
    case 'updateCard':
      return state;
    case 'resetBoard':
      return action.board;
    case 'removeFromList':
      const newClonedState = cloneDeep(state);
      const newListRemovedState = newClonedState.filter(
        (listItem) => listItem.id !== action.list.id
      );
      return newListRemovedState;
    default:
      return state;
  }
};

export default boardReducer;
